import { useCallback } from 'react';
import { RoutePaths } from 'types/enums';
import { useNavigate } from 'react-router-dom';
import { useAuthentication } from 'contexts/AuthenticationProvider/AuthenticationProvider';
import { useCreateUserRecentSearch } from 'apollo/userRecentSearch/useCreateUserRecentSearch';
import { analytics } from 'utils';
import { ContentSuggestionParams, ContentSuggestionPayload } from '../types';

export const useNavigateToContent = () => {
    const navigate = useNavigate();
    const { isAuthenticated } = useAuthentication();

    const createUserRecentSearch = useCreateUserRecentSearch({
        isAuthenticated,
    });

    const navigateToContent = useCallback(
        async (suggestion: ContentSuggestionPayload) => {
            const [params, { slug }] = suggestion;

            createUserRecentSearch([suggestion]);

            const page =
                params === ContentSuggestionParams.suggestedlabels
                    ? RoutePaths.Labels
                    : RoutePaths.Packs;

            const destinationPath = `/${page}/${slug}`;

            await analytics.trackSearchPerformed({
                searchQueries: destinationPath,
            });

            navigate(destinationPath);
        },
        [navigate, createUserRecentSearch],
    );

    return { navigateToContent };
};
